"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InputField = void 0;
const react_1 = __importDefault(require("react"));
const react_native_1 = require("react-native");
const InputField_style_1 = require("./InputField.style");
function InputField({ isEditable = true, onChange, secure = false, isNumber = false, isEmail = false, style = [], value, multiline = false, hasError = false, onKeyPress, }) {
    let kbType = 'default';
    if (isNumber) {
        kbType = 'decimal-pad';
    }
    else if (isEmail) {
        kbType = 'email-address';
    }
    return (react_1.default.createElement(react_native_1.TextInput, { value: value, onChangeText: onChange, secureTextEntry: secure, keyboardType: kbType, editable: isEditable, multiline: multiline, autoCapitalize: isEmail ? 'none' : undefined, onKeyPress: onKeyPress, style: [
            ...[
                InputField_style_1.styles.input,
                hasError ? InputField_style_1.styles.error : null,
                multiline ? InputField_style_1.styles.alignTop : null,
            ],
            ...style,
        ] }));
}
exports.InputField = InputField;
